import React from "react";
import { Container, Card, Button } from "react-bootstrap";
import { Check, X } from "react-bootstrap-icons";
import { Currency } from "../../../lib/components/Currency";
import { plural } from "./helpers";

// Render only when there's an active selection — the parent gates on selCount.
export function BulkActionBar({
  selCount,
  selAmount,
  blockedCount,
  approveCount,
  confirmDecline,
  isSaving,
  onRequestDecline,
  onCancelDecline,
  onConfirmDecline,
  onClear,
  onApprove,
}) {
  return (
    <div
      className="position-fixed bottom-0 start-0 end-0"
      style={{ zIndex: 1030 }}
    >
      <Container className="px-3 pb-3" style={{ maxWidth: 768 }}>
        <Card className="bar-enter position-relative shadow-lg">
          <span
            aria-hidden="true"
            className="bar-ring pe-none position-absolute top-0 start-0 end-0 bottom-0"
            style={{
              border: "2px solid var(--bs-success)",
              borderRadius: "inherit",
            }}
          />
          <Card.Body className="d-flex flex-wrap align-items-center gap-2 py-2 px-3">
            {confirmDecline ? (
              <>
                <p className="mb-0 text-body">
                  Decline {plural(selCount, "contract")}? You can reset any of
                  them individually afterward.
                </p>
                <div className="ms-auto d-flex align-items-center gap-2">
                  <Button
                    variant="link"
                    size="sm"
                    onClick={onCancelDecline}
                    disabled={isSaving}
                    className="text-secondary text-decoration-none fw-medium"
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="danger"
                    size="sm"
                    onClick={onConfirmDecline}
                    disabled={isSaving}
                    className="d-inline-flex align-items-center gap-1 fw-semibold"
                  >
                    <X size={16} />
                    Confirm decline
                  </Button>
                </div>
              </>
            ) : (
              <>
                <div className="min-w-0">
                  <p className="fw-medium mb-0">
                    {plural(selCount, "contract")} selected ·{" "}
                    <span className="tnum">
                      <Currency amount={selAmount} />
                    </span>
                  </p>
                  {blockedCount > 0 && (
                    <p className="small text-warning-emphasis mb-0 mt-1">
                      {plural(blockedCount, "contract")} unassigned, can only be
                      declined
                    </p>
                  )}
                </div>
                <div className="ms-auto d-flex align-items-center gap-2">
                  <Button
                    variant="link"
                    size="sm"
                    onClick={onClear}
                    className="text-secondary text-decoration-none fw-medium"
                  >
                    Clear
                  </Button>
                  <Button
                    variant="outline-danger"
                    size="sm"
                    onClick={onRequestDecline}
                    disabled={isSaving}
                    className="d-inline-flex align-items-center gap-1 fw-medium"
                  >
                    <X size={16} />
                    Decline {selCount}
                  </Button>
                  <Button
                    variant="success"
                    size="sm"
                    onClick={onApprove}
                    disabled={approveCount === 0 || isSaving}
                    title={
                      approveCount === 0
                        ? "Selected contracts have no agent"
                        : undefined
                    }
                    className="d-inline-flex align-items-center gap-1 fw-semibold"
                  >
                    <Check size={16} />
                    Approve {approveCount}
                  </Button>
                </div>
              </>
            )}
          </Card.Body>
        </Card>
      </Container>
    </div>
  );
}
